import { useState } from "react"
import { api, type IAPIParams } from "@/utils"

export function useAPIDownload() {
  const [loading, setLoading] = useState<string | null>(null)
  const [error, setError] = useState(null)

  const downloadAPIFile = async (path: string, filename: string, params: IAPIParams) => {
    setLoading(path)
    setError(null)
    try {
      const response = await api.get(path, { params, responseType: "blob" })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")

      link.href = url
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
    } catch (err) {
      setError(err as any)
    } finally {
      setLoading(null)
    }
  }
  return { downloadAPIFile, loading, error }
}
